module.exports = __webpack_public_path__ + "static/media/Serenity soffa 4sits Sense 4001 beige detalj 2024 6.03e3668e.jpg";